import { Cell } from '@table-library/react-table-library/table';

import {
    evidenceFieldColumn as fieldColumn,
    evidenceValueColumn as valueColumn,
} from '../GscTools/columns';

/**
 * The columns of the four evidence tables, built on the shared evidence columns: an absent value
 * reads "Not returned", a URL is a link, and a row's tone colours what Google returned.
 */

/** Block 01 — the request as sent. */
export const REQUEST_COLUMNS = (t) => [
    fieldColumn(t('tools.url_inspection.request.input')),
    valueColumn(t, { label: t('tools.url_inspection.request.value') }),
];

/** Block 02 — the returned field, its reading, and the value exactly as Google returned it. */
export const STATUS_COLUMNS = (t) => [
    fieldColumn(t('tools.url_inspection.status.field')),
    valueColumn(t, {
        label: t('tools.url_inspection.status.reading'),
        key: 'reading',
        cellSize: 'minmax(200px, 1.4fr)',
    }),
    {
        label: t('tools.url_inspection.status.raw'),
        key: 'raw',
        data: 'raw',
        sortType: 'string',
        cellSize: 'minmax(200px, 1.4fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data ?? '';
            if (!data) return <span className="text-muted">—</span>;
            return <code className="gsc-tool-expression">{data}</code>;
        },
    },
];

/** Block 03 — each canonical and discovery reference Google returned. */
export const CANONICAL_COLUMNS = (t) => [
    fieldColumn(t('tools.url_inspection.canonical.evidence')),
    valueColumn(t, { label: t('tools.url_inspection.canonical.value') }),
];

/** Block 04 — detected rich-result items and the issues returned for them. */
export const RICH_COLUMNS = (t) => [
    {
        label: t('tools.url_inspection.rich.type'),
        key: 'type',
        data: 'type',
        sortType: 'string',
        cellSize: 'minmax(150px, 1fr)',
        Component: Cell,
    },
    {
        label: t('tools.url_inspection.rich.item'),
        key: 'item',
        data: 'item',
        sortType: 'string',
        cellSize: 'minmax(200px, 1.4fr)',
        Component: Cell,
    },
    valueColumn(t, {
        label: t('tools.url_inspection.rich.issue'),
        key: 'issue',
        cellSize: 'minmax(240px, 2fr)',
    }),
    {
        label: t('tools.url_inspection.rich.severity'),
        key: 'severity',
        data: 'severity',
        sortType: 'string',
        cellSize: 'minmax(110px, 0.7fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data ?? '';
            if (!data) return <span className="text-muted">—</span>;
            return <code className="gsc-tool-expression">{data}</code>;
        },
    },
];
